import React from 'react';
export const StarOutlineIcon = ({
  strokeWidth = 1.25,
  ...props
}) => (/*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-color)",
  strokeWidth: strokeWidth,
  d: "m12.41 18.252 4.73 3c.61.39 1.36-.19 1.18-.89l-1.37-5.38a.765.765 0 0 1 .02-.45c.05-.15.13-.28.25-.38l4.24-3.53c.55-.46.27-1.39-.45-1.43l-5.53-.36c-.15-.01-.3-.06-.42-.15s-.21-.21-.27-.36l-2.06-5.19a.736.736 0 0 0-.28-.37.798.798 0 0 0-.9 0c-.13.09-.23.22-.28.37l-2.06 5.19c-.06.15-.15.27-.27.36s-.27.14-.42.15l-5.53.36c-.72.04-1 .97-.45 1.43l4.24 3.53c.12.1.21.23.25.38.05.14.06.3.02.45l-1.27 4.99c-.21.84.69 1.53 1.41 1.07l4.4-2.79c.12-.08.26-.12.41-.12s.29.04.41.12h0z"
})));